import {
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
} from '@dixa/lib-shared-habla';

import styles from './messengerSecretModal.module.scss';

export type DeleteSecretModalComponentProps = {
  /** Whether the modal is open. */
  isOpen: boolean;
  /** Whether the form is submitting. */
  isSubmitting: boolean;
  /** Secret id. */
  id: string;
  /**
   * Callback for deleting secret.
   *
   * @param id - Secret id
   */
  onDelete: (id: string) => void;
  /** Callback for hiding the modal. */
  hide: () => void;
};

/** Presentational component for deleting messenger secret. */
export const DeleteSecretModalComponent = ({
  isOpen,
  id,
  isSubmitting,
  onDelete,
  hide,
}: DeleteSecretModalComponentProps): JSX.Element => {
  return (
    <Modal isOpen={isOpen} onClose={hide} className={styles.modal}>
      <ModalHead
        className={styles.modalHeader}
        title="Are you sure you want to delete this key?"
        onClose={hide}
      />

      <ModalBody className={styles.modalBody}>
        <Text.Paragraph>
          The automatic verification that is set up with this key will no longer
          work.
        </Text.Paragraph>
      </ModalBody>

      <ModalFoot
        className={styles.modalFooter}
        cancelOnClick={hide}
        confirmName="Delete"
        confirmOnClick={() => onDelete(id)}
        confirmProps={{ disabled: isSubmitting }}
      />
    </Modal>
  );
};
